import React from "react";

interface Props {
    size?: number,
    color?: string,
}

const SvgInstagram = ({size = 16, color = '#FFF'}: Props) => (
    <svg width={size} height={size} viewBox="0 0 16 16">
        <path
            fill={color}
            d="M5 0h6a5 5 0 014.995 4.783L16 5v6a5 5 0 01-4.783 4.995L11 16H5a5 5 0 01-4.995-4.783L0 11V5A5 5 0 014.783.005L5 0h6zm6 1.5H5a3.504 3.504 0 00-3.495 3.308L1.5 5v6a3.504 3.504 0 003.308 3.495L5 14.5h6a3.504 3.504 0 003.495-3.308L14.5 11V5c0-1.93-1.57-3.5-3.5-3.5zM8 4a4 4 0 110 8 4 4 0 010-8zm0 1.5A2.503 2.503 0 005.5 8c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-1.379-1.122-2.5-2.5-2.5zm4.3-2.333a.533.533 0 110 1.067.533.533 0 010-1.067z"
        />
    </svg>
);

export default SvgInstagram;